module.exports = __webpack_public_path__ + "img/add_icon_hcg.7d60c498.png";